import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const sample_videos = [
  {
    title: "Getting Started",
    url: "https://www.youtube.com/embed/gobdrqcg0zg",
  },
];

function SampleVideos({ isOpen, toggle }) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>Help & Tutorials</ModalHeader>
      <ModalBody>
        <div className="row">
          {sample_videos.map((video, index) => (
            <div className="col-md-6 mb-4" key={index}>
              <div className="ratio ratio-16x9">
                <iframe
                  src={video.url}
                  title={video.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className="text-center fw-bold mt-2">{video.title}</div>
            </div>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
}

export default SampleVideos;
